module.exports = __webpack_public_path__ + "static/assets/b12ba10eb74c93a53d2ac72c0b6d01be.svg";